
<div class="alerts-page">

  <h3>Mes alertes </h3>

  <mat-list >
    @for (alert of (myProfile$ | async)!.alerts; track alert; let i = $index) {
      <mat-list-item
        >
        <span matListItemTitle>Alerte {{ i }} {{ alert.active?"Active":"Inactive"}}  </span>
        @if (alert.criteria.makes !== undefined) {
          <span  matListItemLine >Marques: {{ alert.criteria.makes }}  </span>
        }
        @if (alert.criteria.models !== undefined) {
          <span matListItemLine>Modeles: {{ alert.criteria.models }} </span>
        }
        <span matListItemLine>Annee: De {{ alert.criteria.yearMin }} a {{ alert.criteria.yearMax }} </span>
        <span matListItemLine>Prix: De {{ alert.criteria.priceMin }} a {{ alert.criteria.priceMax }} FCFA</span>
        <br />
      </mat-list-item>
    }
  </mat-list>
</div>
